/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { ref } from 'ember-ref-bucket';
import config from 'volta/config/environment';

import { action } from '@ember/object';
import Component from '@glimmer/component';

interface BvBackdropSignature {
  Args: {
    onClick?: () => void;
    onTransitionEnd?: () => void;
    belowAppHeader?: boolean;
    hidden?: boolean;
    transparent?: boolean;
  };
  Blocks: {
    default: [];
  };
  Element: HTMLDivElement;
}

export const BvBodyHasBackdropClassName = 'bv-body--has-backdrop';

export default class BvBackdropComponent extends Component<BvBackdropSignature> {
  destinationElement = config.APP.rootElement
    ? document.querySelector(config.APP.rootElement)!
    : document.body;
  lastMouseDownElement?: HTMLElement;
  BvBodyHasBackdropClassName = BvBodyHasBackdropClassName;

  @ref('backdropElement')
  backdropElement?: HTMLElement;

  @action
  handleMouseDown(e: MouseEvent) {
    this.lastMouseDownElement = e.target as HTMLElement;
  }

  @action
  handleMouseUp(_e: MouseEvent) {
    if (this.lastMouseDownElement === this.backdropElement) {
      this.args.onClick?.();
    }
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    BvBackdrop: typeof BvBackdropComponent;
    'bv-backdrop': typeof BvBackdropComponent;
  }
}
